import { ArrowRightIcon } from '@heroicons/react/solid';
import clsx from 'clsx';
import Image, { StaticImageData } from 'next/image';
import React from 'react';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import ButtonDefault, { ButtonVariants } from '../basic/button';
import { LiveEmptyScreen } from '../../../../assets';

interface Props {
  heading?: string;
  desc?: React.ReactNode;
  icon?: string | StaticImageData;
  iconSize?: { width?: number; height?: number };
  onPrimaryText?: string;
  onSecondaryText?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  noIcon?: boolean;
}

const LibraryEmptyState: React.FC<Props> = ({
  heading = 'No Streaming right now',
  desc,
  icon = LiveEmptyScreen,
  iconSize,
  onPrimaryClick,
  onSecondaryClick,
  onPrimaryText,
  onSecondaryText = 'Explore More',
  noIcon = false,
}) => {
  return (
    <div>
      <div className='flex justify-center pt-10 pb-20 md:pt-20'>
        <span
          className={clsx(
            iconSize?.width ? 'gap-y-1' : 'gap-y-4',
            'flex flex-col justify-center text-white',
          )}
        >
          <ShouldRender check={!noIcon}>
            <div className='flex justify-center'>
              <Image
                alt='LiveEmptyScreen'
                src={icon}
                width={iconSize?.width ?? 200}
                height={iconSize?.height ?? 170}
              />
            </div>
          </ShouldRender>
          <p className='font-semibold text-center'>{heading}</p>
          <span className='flex justify-center'>
            <p className='flex justify-center text-center text-textDarkGrayColor w-2/3'>
              {desc}
            </p>
          </span>
          <div className='flex justify-center gap-x-4 mt-4'>
            <ButtonDefault
              variant={ButtonVariants.PRIMARY}
              size={4}
              className='whitespace-nowrap flex justify-center items-center gap-x-2 text-white text-sm font-medium px-5 py-2 rounded-lg'
              onClick={onPrimaryClick}
            >
              {onPrimaryText}
            </ButtonDefault>
            <ShouldRender check={onSecondaryClick}>
              <ButtonDefault
                variant={ButtonVariants.UNSTYLED}
                size={4}
                className='bg-[#383838] whitespace-nowrap flex justify-center items-center text-white text-sm font-medium px-5 py-2 rounded-lg'
                onClick={onSecondaryClick}
              >
                {onSecondaryText}
                <ArrowRightIcon className='ml-2 w-4 h-4' />
              </ButtonDefault>
            </ShouldRender>
          </div>
        </span>
      </div>
    </div>
  );
};

export default LibraryEmptyState;
